import React from 'react';
import Link from 'next/link';
import { cn } from '@/lib/twUtils';

export interface ArrowLinkProps extends Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  'href'
> {
  href?: string;
  /** Rende solo l'aspetto, senza <a>: per card già interamente cliccabili */
  asText?: boolean;
  children: React.ReactNode;
}

const base =
  'group/arrow inline-flex items-center gap-1.5 text-[0.875rem] font-semibold text-accent ds-focus rounded-sm';

/** Link testuale con freccia, terza gerarchia dopo le CTA piene e in outline. */
const ArrowLink = ({ href, asText = false, className, children, ...props }: ArrowLinkProps) => {
  const content = (
    <>
      {children}
      <span
        aria-hidden
        className="transition-transform duration-150 group-hover/arrow:translate-x-0.5 motion-reduce:transition-none"
      >
        →
      </span>
    </>
  );

  if (asText || !href) {
    return <span className={cn(base, className)}>{content}</span>;
  }

  return (
    <Link href={href} className={cn(base, 'hover:text-accent-600', className)} {...props}>
      {content}
    </Link>
  );
};

export default ArrowLink;
